export default __webpack_public_path__ + "static/media/6d282fe5fe1735841f10e87a477e57e7.svg";